<template>
  <div class="layout-wrapper">
    <HeaderNav class="header-nav" :isDashboard="false" :searchQuery="searchQuery"
      @update:searchQuery="$emit('update:searchQuery', $event)" />
    <TabsNavigation class="tabs-navigation" />

    <main ref="pageWrapper" class="main-content">
      <slot />
      <HomeFooter />
    </main>
    <BottomNav class="bottom-nav" />
    <chatbot />
  </div>
</template>

<script>
import HeaderNav from "@/layouts/includes/frontend/HeaderNav.vue";
import TabsNavigation from "@/layouts/includes/frontend/TabsNavigation.vue";
import HomeFooter from "@/layouts/includes/frontend/HomeFooter.vue";
import BottomNav from '@/layouts/includes/frontend/BottomNav.vue';
import { gsapAnimations } from "@/services/gsapAnimations";
import Chatbot from '@/components/templates/Chatbot.vue';

export default {
  name: "DefaultLayout",
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
  components: {
    HeaderNav,
    HomeFooter,
    TabsNavigation,
    BottomNav,
    Chatbot,
  },

  watch: {
    $route() {
      this.animatePageChange();
    },
  },

  mounted() {
    this.animatePageChange(); // initial load animation
  },

  methods: {
    animatePageChange() {
      gsapAnimations.animatePageChange(this.$refs.pageWrapper);
    }
  },
};
</script>

<style scoped>
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* GSAP animation classes */
.gsap-fade-slide-enter-active,
.gsap-fade-slide-leave-active {
  transition: none;
}

.gsap-fade-slide-enter,
.gsap-fade-slide-leave-to {
  opacity: 0;
}
</style>